export interface ConditionOption {
  label: string
  value: string
}

export const CONDITION_OPTIONS: ConditionOption[] = [
  { label: 'New', value: 'new' },
  { label: 'Like New', value: 'like_new' },
  { label: 'Very Good', value: 'very_good' },
  { label: 'Good', value: 'good' },
  { label: 'Acceptable', value: 'acceptable' }
]

/** How condition reads in listing copy (e.g. book descriptions). Values stay snake_case for APIs/DB. */
const CONDITION_FOR_DESCRIPTION: Record<string, string> = {
  new: 'New',
  like_new: 'Like new',
  very_good: 'Very good',
  good: 'Good',
  acceptable: 'Acceptable'
}

export function formatAmazonConditionForDescription(conditionValue: string): string {
  return CONDITION_FOR_DESCRIPTION[conditionValue] ?? conditionValue
}
